// extracted by mini-css-extract-plugin
export default {"contact-container":"Contact_contact-container__7+cAN","contact-details":"Contact_contact-details__zdT03","footer":"Contact_footer__KaQhp"};